import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./components/navbar";
import Sidebar from "./sidebar";
import "./App.css";

const Layout = () => {
  return (
    <>
      <Navbar />
      <div className="layout">
        <Sidebar />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
